import { Link, Typography } from '@one-thd/sui-atomic-components';
import React from 'react';
import { PRIVACY_PATH } from '../constants';

const DisclaimerBox = () => {
  return (
    <>
      <Typography variant="body-base" height="none">
        {`Note you may experience some delays in your request if you have recently
         submitted a request to exercise your privacy rights.
         Please allow sufficient time for your request to be processed.`}
      </Typography>
    </>
  );
};

export default DisclaimerBox;
